import React from "react";
import "./styles/Registration.css";
import CardPseudo from "../components/registration/CardPseudo";

export default function Registration() {
  return (
    <div className="div-registration">
      <div className="/bloc-registration">
        <CardPseudo />
      </div>
    </div>
  );
}
